import type { BrandColorPalette } from './types';

export const BRAND_COLOR_PALETTES = {
  default_blue: {
    brand_primary: '#0779FF',
    brand_primary_hover: '#175CD3',
    brand_primary_highlight: '#84CAFF',
    brand_primary_mid: '#1C86FF',
    brand_primary_dark: '#043E80',
    brand_secondary: '#2F6CCE',
    brand_accent_start: '#1570ef',
    brand_accent_end: '#9e77ed',
    brand_accent_light_start: '#f0f6ff',
    brand_accent_light_end: '#eee6ff',
    brand_complementary_accent: 'rgba(0,160,53,0.9)',
    brand_auth_gradient_mid: 'rgb(24,49,161)',
    brand_auth_gradient_end: 'rgb(1,36,151)',
    brand_auth_warp_mid: 'rgb(39,86,240)',
  },
  navy: {
    brand_primary: '#3E4784',
    brand_primary_hover: '#363F72',
    brand_primary_highlight: '#AFB5D9',
    brand_primary_mid: '#4E5BA6',
    brand_primary_dark: '#101323',
    brand_secondary: '#293056',
    brand_accent_start: '#3E4784',
    brand_accent_end: '#717BBC',
    brand_accent_light_start: '#EAECF5',
    brand_accent_light_end: '#F8F9FC',
    brand_complementary_accent: 'rgba(6,89,134,0.9)',
    brand_auth_gradient_mid: '#293056',
    brand_auth_gradient_end: '#101323',
    brand_auth_warp_mid: '#4E5BA6',
  },
  charcoal: {
    brand_primary: '#344054',
    brand_primary_hover: '#1D2939',
    brand_primary_highlight: '#E4E7EC',
    brand_primary_mid: '#475467',
    brand_primary_dark: '#101828',
    brand_secondary: '#101828',
    brand_accent_start: '#344054',
    brand_accent_end: '#667085',
    brand_accent_light_start: '#F9FAFB',
    brand_accent_light_end: '#FCFCFD',
    brand_complementary_accent: 'rgba(62,108,143,0.9)',
    brand_auth_gradient_mid: '#101828',
    brand_auth_gradient_end: '#101828',
    brand_auth_warp_mid: '#475467',
  },
  cyan: {
    brand_primary: '#0086C9',
    brand_primary_hover: '#026AA2',
    brand_primary_highlight: '#B9E6FE',
    brand_primary_mid: '#0BA5EC',
    brand_primary_dark: '#0B4A6F',
    brand_secondary: '#065986',
    brand_accent_start: '#0086C9',
    brand_accent_end: '#36BFFA',
    brand_accent_light_start: '#F0F9FF',
    brand_accent_light_end: '#F5FBFF',
    brand_complementary_accent: 'rgba(14,116,144,0.9)',
    brand_auth_gradient_mid: '#065986',
    brand_auth_gradient_end: '#0B4A6F',
    brand_auth_warp_mid: '#0BA5EC',
  },
  magenta: {
    brand_primary: '#DD2590',
    brand_primary_hover: '#C11574',
    brand_primary_highlight: '#FCCEEE',
    brand_primary_mid: '#EE46BC',
    brand_primary_dark: '#851651',
    brand_secondary: '#9E165F',
    brand_accent_start: '#DD2590',
    brand_accent_end: '#F670C7',
    brand_accent_light_start: '#FDF2FA',
    brand_accent_light_end: '#FEF6FB',
    brand_complementary_accent: 'rgba(74,31,184,0.9)',
    brand_auth_gradient_mid: '#9E165F',
    brand_auth_gradient_end: '#851651',
    brand_auth_warp_mid: '#EE46BC',
  },
  crimson: {
    brand_primary: '#B42318',
    brand_primary_hover: '#912018',
    brand_primary_highlight: '#FECDCA',
    brand_primary_mid: '#D92D20',
    brand_primary_dark: '#7A271A',
    brand_secondary: '#7A271A',
    brand_accent_start: '#B42318',
    brand_accent_end: '#F04438',
    brand_accent_light_start: '#FEF3F2',
    brand_accent_light_end: '#FFFBFA',
    brand_complementary_accent: 'rgba(180,71,8,0.9)',
    brand_auth_gradient_mid: '#7A271A',
    brand_auth_gradient_end: '#7A271A',
    brand_auth_warp_mid: '#D92D20',
  },
  amber: {
    brand_primary: '#C4320A',
    brand_primary_hover: '#9C2A10',
    brand_primary_highlight: '#FDDCAB',
    brand_primary_mid: '#EC4A0A',
    brand_primary_dark: '#7E2410',
    brand_secondary: '#7E2410',
    brand_accent_start: '#C4320A',
    brand_accent_end: '#FB6514',
    brand_accent_light_start: '#FFF6ED',
    brand_accent_light_end: '#FFFAF5',
    brand_complementary_accent: 'rgba(180,35,24,0.9)',
    brand_auth_gradient_mid: '#7E2410',
    brand_auth_gradient_end: '#7E2410',
    brand_auth_warp_mid: '#EC4A0A',
  },
  royal: {
    brand_primary: '#444CE7',
    brand_primary_hover: '#3538CD',
    brand_primary_highlight: '#C7D7FE',
    brand_primary_mid: '#6172F3',
    brand_primary_dark: '#2D3282',
    brand_secondary: '#2D31A6',
    brand_accent_start: '#444CE7',
    brand_accent_end: '#8098F9',
    brand_accent_light_start: '#EEF4FF',
    brand_accent_light_end: '#F5F8FF',
    brand_complementary_accent: 'rgba(0,134,201,0.9)',
    brand_auth_gradient_mid: '#2D31A6',
    brand_auth_gradient_end: '#2D3282',
    brand_auth_warp_mid: '#6172F3',
  },
  violet: {
    brand_primary: '#6938EF',
    brand_primary_hover: '#5925DC',
    brand_primary_highlight: '#D9D6FE',
    brand_primary_mid: '#7A5AF8',
    brand_primary_dark: '#3E1C96',
    brand_secondary: '#4A1FB8',
    brand_accent_start: '#6938EF',
    brand_accent_end: '#9B8AFB',
    brand_accent_light_start: '#F4F3FF',
    brand_accent_light_end: '#FAFAFF',
    brand_complementary_accent: 'rgba(158,22,95,0.9)',
    brand_auth_gradient_mid: '#4A1FB8',
    brand_auth_gradient_end: '#3E1C96',
    brand_auth_warp_mid: '#7A5AF8',
  },
  hot_pink: {
    brand_primary: '#EE46BC',
    brand_primary_hover: '#DD2590',
    brand_primary_highlight: '#FCCEEE',
    brand_primary_mid: '#F670C7',
    brand_primary_dark: '#9E165F',
    brand_secondary: '#C11574',
    brand_accent_start: '#EE46BC',
    brand_accent_end: '#FAA7E0',
    brand_accent_light_start: '#FDF2FA',
    brand_accent_light_end: '#FEF6FB',
    brand_complementary_accent: 'rgba(105,56,239,0.9)',
    brand_auth_gradient_mid: '#C11574',
    brand_auth_gradient_end: '#9E165F',
    brand_auth_warp_mid: '#F670C7',
  },
  orange_red: {
    brand_primary: '#EC4A0A',
    brand_primary_hover: '#C4320A',
    brand_primary_highlight: '#FDDCAB',
    brand_primary_mid: '#FB6514',
    brand_primary_dark: '#7E2410',
    brand_secondary: '#9C2A10',
    brand_accent_start: '#EC4A0A',
    brand_accent_end: '#FD853A',
    brand_accent_light_start: '#FFF6ED',
    brand_accent_light_end: '#FFFAF5',
    brand_complementary_accent: 'rgba(180,35,24,0.9)',
    brand_auth_gradient_mid: '#9C2A10',
    brand_auth_gradient_end: '#7E2410',
    brand_auth_warp_mid: '#FB6514',
  },
  rose: {
    brand_primary: '#E31B54',
    brand_primary_hover: '#C01048',
    brand_primary_highlight: '#FECDD6',
    brand_primary_mid: '#F63D68',
    brand_primary_dark: '#89123E',
    brand_secondary: '#A11043',
    brand_accent_start: '#E31B54',
    brand_accent_end: '#FD6F8E',
    brand_accent_light_start: '#FFF1F3',
    brand_accent_light_end: '#FFF5F6',
    brand_complementary_accent: 'rgba(158,22,95,0.9)',
    brand_auth_gradient_mid: '#A11043',
    brand_auth_gradient_end: '#89123E',
    brand_auth_warp_mid: '#F63D68',
  },
  teal: {
    brand_primary: '#004C55',
    brand_primary_hover: '#003940',
    brand_primary_highlight: '#99C8CD',
    brand_primary_mid: '#006570',
    brand_primary_dark: '#002830',
    brand_secondary: '#003540',
    brand_accent_start: '#004C55',
    brand_accent_end: '#008091',
    brand_accent_light_start: '#F0F9FA',
    brand_accent_light_end: '#F5FBFC',
    brand_complementary_accent: 'rgba(0,134,201,0.9)',
    brand_auth_gradient_mid: '#003540',
    brand_auth_gradient_end: '#002830',
    brand_auth_warp_mid: '#006570',
  },
  emerald: {
    brand_primary: '#027A48',
    brand_primary_hover: '#05603A',
    brand_primary_highlight: '#A6F4C5',
    brand_primary_mid: '#12B76A',
    brand_primary_dark: '#054F31',
    brand_secondary: '#05603A',
    brand_accent_start: '#027A48',
    brand_accent_end: '#32D583',
    brand_accent_light_start: '#ECFDF3',
    brand_accent_light_end: '#F6FEF9',
    brand_complementary_accent: 'rgba(0,134,108,0.9)',
    brand_auth_gradient_mid: '#05603A',
    brand_auth_gradient_end: '#054F31',
    brand_auth_warp_mid: '#12B76A',
  },
  forest: {
    brand_primary: '#2E7D32',
    brand_primary_hover: '#1B5E20',
    brand_primary_highlight: '#C8E6C9',
    brand_primary_mid: '#43A047',
    brand_primary_dark: '#123D20',
    brand_secondary: '#1F5C2D',
    brand_accent_start: '#2E7D32',
    brand_accent_end: '#66BB6A',
    brand_accent_light_start: '#F1F8E9',
    brand_accent_light_end: '#F7FBF2',
    brand_complementary_accent: 'rgba(0,97,76,0.9)',
    brand_auth_gradient_mid: '#1F5C2D',
    brand_auth_gradient_end: '#123D20',
    brand_auth_warp_mid: '#43A047',
  },
} as const satisfies Record<string, BrandColorPalette>;

export type BrandColorPresetName = keyof typeof BRAND_COLOR_PALETTES;

export const BRAND_COLOR_PRESET_NAMES = Object.keys(
  BRAND_COLOR_PALETTES,
) as Array<BrandColorPresetName>;
